import React from "react";

import { Fade } from "react-reveal";
import "./Greeting.css";
import landingPerson from "../../assets/lottie/person.json";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";

import { greeting } from "../../portfolio";

export default function Greeting() {
  return (
    <Fade bottom duration={1300} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 style={{display:'none'}}>Jhon Brichman Bellido Vargas</h1>
              <h1 className="greeting-text">
                {greeting.greetingText}{" "}
                <span className="glitch">{greeting.greetingName}</span>
              </h1>
              <p className="greeting-text-p">{greeting.subTitle}</p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contáctame" href="#contact" />
                <Button
                  text="Mi curriculum"
                  newTab={true}
                  href={require(`../../assets/cv_Bellido_Jhon.pdf`)}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {<DisplayLottie animationData={landingPerson} />}
          </div>
        </div>
      </div>
    </Fade>
  );
}
